export function convertImageToBase64(image: any): Promise<string | undefined> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = () => {
      resolve(reader?.result?.toString()?.split(",")[1]);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
}
